<template>
  <v-col>
    <div class="text-h4">Account Contacts</div>
    <template>
      <div>
        Please add a contact for <strong>ALL</strong> required roles.
        <MoreInfoToolTip msg="These are the individuals listed as order and account contacts.
              They will be updated on order completion progress and, where selected,
              have access to your account information." />
      </div>
      <template>
        <div class="text-left my-3">
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
            <template v-slot:activator="{ on, attrs }">
              <div>
                <div color="third" dark v-bind="attrs"></div>
                <div>
                  <div>
                    <!-- {{ fullfilledPermissions }} -->
                    <div v-for="roleObj in sortedVisibleRoles" :key="roleObj.name"
                      :class="['role-card', hasRole(roleObj.name).length > 0 ? 'role-card--has' : ((roleObj.required) ? 'role-card--missing' : 'role-card--optional')]">
                      <div v-if="roleObj.name === 'IT Vendor' && !(formData.generalData.has_vendor === 'y')">
                        <v-radio-group v-model="formData.generalData.has_vendor">
                          <template v-slot:label>
                            <div>
                              Please Let us know if you have a <strong>IT Vendor</strong>.
                            </div>
                          </template>
                          <v-radio value="y">
                            <template v-slot:label>
                              <div>Yes, I do have IT Vendor</div>
                            </template>
                          </v-radio>

                          <v-radio value="n">
                            <template v-slot:label>
                              <div>No, I do not have a IT Vendor</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </div>
                      <div
                        v-else-if="roleObj.name === 'PBX - Phone System Vendor' && !(formData.generalData.has_pbx_vendor === 'y')">
                        <v-radio-group v-model="formData.generalData.has_pbx_vendor">
                          <template v-slot:label>
                            <div>
                              Do you have a <strong>Phone Service Vendor</strong>?
                            </div>
                          </template>
                          <v-radio value="y">
                            <template v-slot:label>
                              <div>Yes, I do have a IT Vendor</div>
                            </template>
                          </v-radio>

                          <v-radio value="n">
                            <template v-slot:label>
                              <div>No, I do not have a IT Vendor</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </div>
                      <div v-else>

                        <div v-if="roleObj.required && !(hasRole(roleObj.name).length > 0)" class="required-badge">
                          required
                        </div>

                        <div class="role-card__grid">
                          <!-- LEFT -->
                          <div class="role-card__left">
                            <h3>
                              {{
                                roleObj.name === "Billing Contact"
                                  ? "Accounts Payable Contact"
                                  : roleObj.name === "PBX - Phone System Vendor"
                                    ? "Phone System Provider"
                                    : roleObj.name
                              }}
                            </h3>
                            <p>{{ roleObj.description }}</p>
                            <v-btn
                              v-if="!(hasRole(roleObj.name).length && (roleObj.name === 'Billing Contact' || roleObj.name === 'Main Contact' || roleObj.name === 'Local Contact'))"
                              @click="() => { openAddMenu(roleObj.name) }">
                              Add {{ hasRole(roleObj.name).length ? "another" : "" }} Contact
                            </v-btn>
                            <div v-if="roleObj.name === 'IT Vendor'">
                              <v-btn @click="formData.generalData.has_vendor = 'n'">I don't have a IT Vendor</v-btn>
                            </div>

                            <div v-if="roleObj.name === 'PBX - Phone System Vendor'">
                              <v-btn @click="formData.generalData.has_pbx_vendor = 'n'">I don't have a Phone System
                                Vendor</v-btn>
                            </div>

                          </div>

                          <!-- RIGHT -->
                          <v-row class="role-card__right" v-if="hasRole(roleObj.name).length">
                            <v-card variant="outlined" v-for="(contact, i) in hasRole(roleObj.name)"
                              :key="contact.id ?? `${roleObj.name}-${i}`" class="role-card__contact pa-3">
                              <div><strong>First:</strong> {{ getContactField(contact, 'first') }}</div>
                              <div><strong>Last:</strong> {{ getContactField(contact, 'last') }}</div>
                              <div><strong>Email:</strong> {{ getContactField(contact, 'email') }}</div>
                              <div><strong>Phone:</strong> {{ getContactField(contact, 'phone') }}</div>

                              <div v-if="roleObj.name === 'Billing Contact'">
                                <div><strong>Address:</strong> {{ getContactField(contact, 'address') }}</div>
                                <div><strong>Company:</strong> {{ getContactField(contact, 'company') }}</div>
                                <div><strong>PIN:</strong> {{ getContactField(contact, 'pin') }}</div>
                                <div><strong>Purchase Order Number:</strong> {{ getContactField(contact, 'ordernumber')
                                }}</div>
                              </div>

                              <div v-if="roleObj.name === 'PBX - Phone System Vendor' || roleObj.name === 'IT Vendor'">
                                <div><strong>Company:</strong> {{ getContactField(contact, 'company') }}</div>
                              </div>
                              <v-btn @click="() => { editContact(contact.idx); editingRole = roleObj.name }">Edit
                                Contact</v-btn>
                              <v-btn @click="removeRoleFromContact(contact.idx, roleObj.name)">Remove Contact</v-btn>
                              <hr v-if="i < hasRole(roleObj.name).length - 1" />
                            </v-card>
                          </v-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </template>

            <v-card>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <VContactsAutocomplete :contact.sync="contact" :globalContacts="allContacts"
                      @contactInfo="setContact" :role="editingRole"
                      :description="roles.find(r => r.name === editingRole)?.description || ''" icon />
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn text color="error" @click="menu = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </template>

      <v-list subheader>

        <v-dialog v-model="assignMenu" v-if="formData.contacts.length" persistent width="fit-content">
          <v-card>
            <v-card-title class="py-2 text-subtitle-2">
              <h2>
                Want to use {{ (formData.contacts[0].first ?? '') + ' ' + (formData.contacts[0].last ?? '') }}
                as a contact for other roles?
              </h2>
            </v-card-title>

            <v-card-text class="py-0">
              <v-list dense class="py-0">
                <v-list-item v-for="role in unassignedVisibleRoles" :key="role.name" class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="text-body-2">
                      {{ role.name === "Billing Contact" ? 'Accounts Payable Contact' : role.name }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action class="my-0">
                    <v-checkbox dense hide-details class="ma-0" :value="role.name" v-model="formData.contacts[0].roles"
                      @change="addedRole(role.name, $event)" />
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>

            <v-card-actions class="py-1">
              <v-btn text @click="useForAllRoles">Use for all roles</v-btn>
              <v-spacer />
              <v-btn color="primary" large text @click="assignMenu = false">Continue / Add Another Contact</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">
                Please Complete Contact Information
              </span>
            </v-card-title>
            <v-card-subtitle>
              <span class="first--text">
                you must complete any required information before adding/selecting a contact.
              </span>
            </v-card-subtitle>
            <v-card-text>
              <v-form ref="contact_form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="contactForm.first.value" :rules="contactForm.first.rules" label="First Name*"
                      required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="contactForm.last.value" :rules="contactForm.last.rules" label="Last Name*"
                      required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="contactForm.email.value" :rules="contactForm.email.rules" label="Email*"
                      required></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="contactForm.phone.value" :rules="contactForm.phone.rules"
                      label="Phone Number*" required v-mask="'(###) ###-####'"></v-text-field>
                  </v-col>
                </v-row>
                <div v-if="editingRole === 'IT Vendor' || editingRole === 'PBX - Phone System Vendor'">
                  <v-col cols="6">
                    <v-text-field v-model="contactForm.company.value" label="Company Name*" required
                      :rules="contactForm.company.rules"></v-text-field>
                  </v-col>
                </div>
                <div v-if="editingRole === 'Billing Contact'">
                  <v-row>
                    <v-col cols="6">
                      <v-text-field v-model="contactForm.address.value" :rules="contactForm.address.rules"
                        label="Billing Address*" required></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field v-model="contactForm.ordernumber.value" :rules="contactForm.ordernumber.rules"
                        label="Purchase Order Number (optional)"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field :disabled="generatePin" v-model="contactForm.pin.value"
                        :rules="contactForm.pin.rules" label="Customer PIN #*" required></v-text-field>
                      <p class="grey--text">
                        A Customer PIN # is a 4-digit number to ensure the security of your account.
                        Please ensure you store this number in a safe place as it will be required
                        for any future account changes or inquiries.
                      </p>
                      <v-checkbox v-model="generatePin" label="Randomly Generate a PIN For Me"></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field v-model="contactForm.company.value" label="Company Name*"
                        :rules="contactForm.company.rules" required></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="() => closeContactModal()">
                Close
              </v-btn>
              <v-btn color="third darken-1" text @click="() => validate()">
                {{ getAction }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card class="mx-auto" tile>
          <v-list flat>
            <v-subheader>HINT:</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>
                  * Roles in <b class="first--text">RED</b> are required
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>
                  * Roles in <b class="second--text">GREEN</b>
                  are required roles that have been fullfilled
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-list>
    </template>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MoreInfoToolTip from '@/components/menus/MoreInfoToolTip.vue';
// import ListInfoToolTip from '@/components/menus/ListInfoToolTip.vue';
import VContactsAutocomplete from '@/components/formfields/VContactsAutocomplete.vue';
import _ from 'lodash';

export default {
  name: 'ManageContacts',
  components: { MoreInfoToolTip, VContactsAutocomplete },
  data: () => ({
    generatePin: false,
    action: 'create',
    idxToEdit: null,
    valid: true,
    dialog: false,
    menu: false,
    contact: '',
    contactData: {},
    contactForm: {
      first: {
        value: null,
        rules: [
          (v) => !!v || 'Name is required',
          (v) => (v && v.length < 255) || 'Name must be less than 255 characters',
        ],
      },
      last: {
        value: null,
        rules: [
          (v) => !!v || 'Name is required',
          (v) => (v && v.length < 255) || 'Name must be less than 255 characters',
        ],
      },
      email: {
        value: null,
        rules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/.test(v) || 'E-mail must be valid',
        ],
      },
      phone: {
        value: null,
        rules: [
          (v) => !!v || 'Phone Number is required',
        ],
      },
      roles: {
        value: [],
      },
      pin: {
        value: null,
        rules: [(v) => (v != null && /^\d{4}$/.test(String(v).trim())) || 'Must be exactly 4 numbers'],
      },
      address: {
        value: null,
        rules: [(v) => (typeof v === 'string' ? v.trim().length > 0 : !!v) || 'This field is required'],
      },
      ordernumber: {
        value: null,
      },
      company: {
        value: null,
        rules: [(v) => (typeof v === 'string' ? v.trim().length > 0 : !!v) || 'This field is required'],
      },
    },
    formData: {
      contacts: [],
      generalData: {},
    },
    legacyFields: {
      contacts: [],
      /* **** Legacy Support *** */
      // main contact
      mcp_email: '',
      mcp_name: '',
      mcp_phone: '',
      mcp_mobile: '',
      // local contact
      lcon_name: '',
      lcon_email: '',
      lcon_phone: '',
      lcon_mobile: '',
      // emergency contact
      emergency_contact_email: '',
      ec_office: '',
      ec_mobile: '',
      // portal admin
      portal_name: '',
      portal_email: '',
      portal_phone: '',
      // notifications
      notif_email: [],
      notif_name: [],
      notif_phone: [],
      // colo access
      colo_name: [],
      colo_phone: [],
      colo_email: [],
      // portal accesss???
      // IT vendor info
      vendor_contact_name: '',
      vendor_contact_number: '',
      vendor_contact_email: '',
      // PBX – Phone System vendor info
      pbx_vendor_contact_name: '',
      pbx_vendor_contact_number: '',
      pbx_vendor_contact_email: '',
      /* **** Legacy Support *** */
    },
    fullfilledPermissions: [],
    roles: [
      {
        name: 'Main Contact',
        disabled: false,
        required: true,
        show: false,
        description: 'This is your primary contact for the order.',
      }, {
        name: 'Local Contact',
        disabled: false,
        required: true,
        show: false,
        description: 'This is your local contact for the order. They are the main contact for onsite work and dispatch.',
      }, {
        name: 'Portal Admin',
        disabled: false,
        required: true,
        show: false,
        description: 'This person will receive service notifications',
      }, {
        name: 'Order Notifications',
        disabled: false,
        required: true,
        show: false,
        description: 'Anyone you wish to receive notifications about your order.',
      }, {
        name: 'Colo Access',
        disabled: false,
        required: false,
        show: false,
        description: 'Anyone who needs colo access should be tagged here.',
      }, {
        name: 'IT Vendor',
        disabled: false,
        required: false,
        show: false,
        description: 'If you use a third party to manage your internal phone/network services',
      }, {
        name: 'PBX - Phone System Vendor',
        disabled: false,
        required: false,
        show: false,
        description: 'If you use a third party to manage your internal phone/network services',
      }, {
        name: 'Billing Contact',
        disabled: false,
        required: true,
        show: false,
        description: 'Who handles accounts payable',
      },
    ],
    editingRole: null,
    assignMenu: false,
    justAdded: null,
    showBillingContact: true,
  }),
  created() {
    this.fetchGlobalContactsList('managed');
  },
  mounted() {
    const generalData = _.cloneDeep(this.getFormData.general);
    this.formData = {
      contacts: generalData?.contacts,
      generalData,
    };
  },
  computed: {
    ...mapGetters([
      'getFormData',
      'getGlobalContactsList',
      'getQuoteFacts',
      'isRetail',
      'getProducts',
      'isExistingCustomer',
      // 'updateStoreFormData',
    ]),
    getRolesOptions() {
      const hasColocationProduct = this.getProducts.filter((product) => product.order_type === 'col').length > 0;
      const hasVoiceProduct = this.getProducts.filter((product) => product.is_voice).length > 0;
      const roles = this.roles.map((role) => {
        // Show needed roles
        if (!this.isRetail && ((role.name === 'Local Contact' || role.name === 'Order Notifications' || (role.name === 'Colo Access' && hasColocationProduct) || (role.name === 'Primary Voice Contact' && hasVoiceProduct)))) {
          role.show = true;
        } else if (this.isRetail && (role.name !== 'Colo Access' || hasColocationProduct) && (role.name !== 'Primary Voice Contact' || hasVoiceProduct)) {
          role.show = true;
        }
        // End show needed roles
        if (role.required) {
          if (this.fullfilledPermissions.includes(role.name) && role.name === 'Main Contact') {
            /*
              - since Primary Voice Contact is a product need ability to handle this
              - in the meantime just disable the option
              - if more than 1 voice product, allow for mutliple Primary Voice contacts to display
              - toss another column on quotes_info_contacts (product_id) and filter by that
              - Note: currently only displays role does not actually mutate the field
              -- jesse
            */
            role.disabled = true;
          } else {
            role.disabled = false;
          }
        }
        return role;
      });
      return roles;
    },
    getAction() {
      return this.action;
    },
    addedContacts() {
      const addedContacts = this.formData.contacts.map((item, index) => {
        item.idx = index;
        return item;
      });
      return addedContacts;
    },
    visibleRoles() {
      const hasColocationProduct = this.getProducts.some((product) => product.order_type === 'col');
      const hasVoiceProduct = this.getProducts.some((product) => product.is_voice);
      return this.roles
        .map((role) => {
          const showForNonRetail = !this.isRetail
            && (
              role.name === 'Local Contact'
              || role.name === 'Order Notifications'
              || (role.name === 'Colo Access' && hasColocationProduct)
              || (role.name === 'PBX - Phone System Vendor' && hasVoiceProduct)
            );

          const showForRetail = this.isRetail && (
            (role.name === 'Colo Access' && hasColocationProduct)
            || (role.name === 'PBX - Phone System Vendor' && hasVoiceProduct)
            || role.name === "Local Contact"
            || role.name === "Order Notifications"
          );

          const show = showForNonRetail || showForRetail || role.name === "Main Contact" || ((!this.isExistingCustomer) && (role.name === "Billing Contact" || role.name === "Portal Admin"));
          const disabled = role.required
            ? (role.name === 'Main Contact' && this.fullfilledPermissions.includes(role.name))
            : false;

          return {
            ...role,
            show,
            disabled,
          };
        })
        .filter((role) => role.show);
    },
    sortedVisibleRoles() {
      const roles = Array.isArray(this.visibleRoles) ? this.visibleRoles : [];
      return roles
        .filter((roleObj) => {
          if (this.showBillingContact) return true;
          return roleObj?.name !== "Billing Contact";
        })
        .map((roleObj, idx) => ({
          roleObj,
          idx,
          priority: this.getRolePriority(roleObj),
        }))
        .sort((a, b) => (a.priority - b.priority) || (a.idx - b.idx)) // stable
        .map((x) => x.roleObj);
    },
    unassignedVisibleRoles() { // for fast selecting
      return (this.visibleRoles || []).filter((r) => !(this.hasRole(r.name).length > 0));
    },
    normalizedLocalContacts() {
      return (this.formData.contacts || []).map((c) => ({
        ...c,
        fullname: (c.fullname && String(c.fullname).trim())
          ? String(c.fullname).trim()
          : [c.first, c.last].filter(Boolean).join(' ').trim(),
        email: c.email || '',
        phone: c.phone || '',
      }));
    },
    allContacts() {
      return (this.getGlobalContactsList || []).concat(this.normalizedLocalContacts);
    },
  },
  methods: {
    ...mapActions([
      'fetchGlobalContactsList',
      'updateStoreFormData',
    ]),
    setContact(e) {
      const keys = Object.keys(e);
      keys.forEach((key) => {
        if (this.contactForm[key]) { // this excludes fullname
          this.contactForm[key].value = e[key];
        }
      });
      // set contact name
      this.contact = e.fullname;
    },
    setPermission(permission) {
      this.fullfilledPermissions = [...this.fullfilledPermissions, permission];
    },
    updatePermissions(permissions) {
      this.fullfilledPermissions = permissions.filter((a) => this.fullfilledPermissions
        .includes(a));
    },
    permissionHandler(contacts) {
      contacts = _.cloneDeep(contacts);
      let activeRequiredRoles = [];
      let isNewPermission = false;

      contacts.forEach((contact) => {
        contact.roles.forEach((role) => {
          if (this.isRequired(role)) {
            activeRequiredRoles = [...activeRequiredRoles, role];

            // SET new permission
            if (!this.fullfilledPermissions.includes(role)) {
              isNewPermission = true;
              this.setPermission(role);
            }
          }
        });
      });

      // Check if item has been removed;
      if (!isNewPermission) this.updatePermissions(activeRequiredRoles);
    },
    addContact() {
      if (this.contact === 'New Contact') {
        // Open modal to enter new contact
        // reset fields
        this.contactForm.first.value = null;
        this.contactForm.last.value = null;
        this.contactForm.phone.value = null;
        this.contactForm.email.value = null;
        this.contactForm.company.value = null;
        this.contactForm.address.value = null;
        this.contactForm.pin.value = null;
        this.contactForm.ordernumber.value = null;

        this.dialog = true;
        this.action = 'create';
      } else if (!this.contactForm.first.value
        || !this.contactForm.phone.value
        || !this.contactForm.email.value) {
        // add missing information if data is missing
        this.dialog = true;
        this.action = 'update';
      } else if ((this.editingRole === "Billing Contact") && !(this.contactForm.pin.value && this.contactForm.company.value && this.contactForm.ordernumber.value && this.contactForm.address.value)) {
        this.dialog = true;
        this.action = 'update';
      } else if ((this.editingRole === "IT Vendor" || this.editingRole === "PBX - Phone System Vendor") && !(this.contactForm.company.value)) {
        this.dialog = true;
        this.action = 'update';
      } else {
        // if data complete directly add contact
        const contact = (this.allContacts.filter((a) => a.fullname === this.contact))
          .shift();
        contact.roles = [];

        // add contact to list of contacts
        this.appendContact(contact);

        // resets
        this.menu = false;
      }
      this.contact = '';
    },
    appendContact(contact) {
      this.formData.contacts = [{
        first: contact.first?.value || contact.first,
        last: contact.last?.value || contact.last,
        email: contact.email?.value || contact.email,
        phone: contact.phone?.value || contact.phone,
        roles: [this.editingRole],
        address: contact.address?.value,
        pin: contact.pin?.value,
        company: contact.company?.value,
        ordernumber: contact.ordernumber?.value,
      }, ...this.formData.contacts];
      this.dialog = false;
      // update billing data if billing customer
      if (this.editingRole === "Billing Contact") {
        this.formData.generalData.ap_phone = contact.phone?.value;
        this.formData.generalData.ap_email = contact.email?.value;
        this.formData.generalData.ap_contact = `${contact.first?.value} ${contact.last?.value}`;

        // billing exclusives
        this.formData.generalData.ap_address = contact.address?.value;
        this.formData.generalData.master_pin = contact.pin?.value;
        this.formData.generalData.ap_name = contact.company?.value;
        this.formData.generalData.purchase_order = contact.ordernumber?.value;
      }

      if (this.editingRole === "IT Vendor") {
        this.formData.generalData.vendor_contact_name = `${contact.first.value} ${contact.last.value}`;
        this.formData.generalData.vendor_contact_email = contact.email.value;
        this.formData.generalData.vendor_contact_number = contact.phone.value;
        this.formData.generalData.vendor_company_name = contact.company.value;
      }

      if (this.editingRole === "PBX - Phone System Vendor") {
        this.formData.generalData.pbx_vendor_contact_name = `${contact.first.value} ${contact.last.value}`;
        this.formData.generalData.pbx_vendor_contact_email = contact.email.value;
        this.formData.generalData.pbx_vendor_contact_number = contact.phone.value;
        this.formData.generalData.pbx_vendor_company_name = contact.company.value;
      }
    },
    updateContact() {
      const idx = this.idxToEdit;
      this.formData.contacts.forEach((item) => {
        if (item.idx === idx) {
          item.first = this.contactForm.first.value;
          item.last = this.contactForm.last.value;
          item.fullname = `${this.contactForm.first.value} ${this.contactForm.last.value}`;
          item.email = this.contactForm.email.value;
          item.phone = this.contactForm.phone.value;
          item.roles = this.contactForm.roles.value;
          item.address = this.contactForm.address?.value;
          item.pin = this.contactForm.pin?.value;
          item.company = this.contactForm.company?.value;
          item.ordernumber = this.contactForm.ordernumber?.value;
        }
      });
      if (this.editingRole === "Billing Contact") {
        this.formData.generalData.ap_phone = this.contactForm.phone?.value;
        this.formData.generalData.ap_email = this.contactForm.email?.value;
        this.formData.generalData.ap_contact = `${this.contactForm.first?.value} ${this.contactForm.last?.value}`;

        // billing exclusives
        this.formData.generalData.ap_address = this.contactForm.address?.value;
        this.formData.generalData.master_pin = this.contactForm.pin?.value;
        this.formData.generalData.ap_name = this.contactForm.company?.value;
        this.formData.generalData.purchase_order = this.contactForm.ordernumber?.value;
      }

      if (this.editingRole === "IT Vendor") {
        this.formData.generalData.vendor_company_name = this.contactForm.company?.value;
      }

      if (this.editingRole === "PBX - Phone System Vendor") {
        this.formData.generalData.pbx_vendor_company_name = this.contactForm.company?.value;
      }

      this.dialog = false;
    },
    editContact(idx) {
      const contact = (this.formData.contacts.filter((a) => a.idx === idx)).shift();
      const keys = Object.keys(contact);
      keys.forEach((key) => {
        if (this.contactForm[key]) { // this excludes fullname
          this.contactForm[key].value = contact[key];
        }
      });

      if (contact.roles.includes("Billing Contact")) {
        console.log(this.formData.generalData.ap_address);
        this.contactForm.address.value = this.formData.generalData.ap_address;
        this.contactForm.pin.value = this.formData.generalData.master_pin;
        this.contactForm.company.value = this.formData.generalData.ap_name;
        this.contactForm.ordernumber.value = this.formData.generalData.purchase_order;
      }

      if (contact.roles.includes("IT Vendor")) {
        this.contactForm.company.value = this.formData.generalData.vendor_company_name;
      }

      if (contact.roles.includes("PBX - Phone System Vendor")) {
        this.contactForm.company.value = this.formData.generalData.pbx_vendor_company_name;
      }
      this.action = 'edit';
      this.idxToEdit = idx;
      this.dialog = true;
    },
    deleteContact(idx) {
      // Enable contact in global contacts dropdown
      this.getGlobalContactsList.forEach((a) => {
        if (typeof a === 'object') {
          if (a.fullname === `${this.formData.contacts[idx].first} ${this.formData.contacts[idx].last}`) a.disabled = false;
        }
      });

      // unassign legacy fields
      this.formData.contacts[idx].roles.forEach((role) => {
        this.nullifyLegacyField(role, this.formData.contacts[idx]);
      });

      // remove contact from list of contacts
      const contact = this.formData.contacts.filter((a) => a.idx !== idx);
      this.formData.contacts = [...contact];
    },
    closeContactModal() {
      this.dialog = false;
      this.reset();
    },
    removeRole(idx, item) {
      const contact = (this.formData.contacts.filter((a) => a.idx === idx)).shift();
      const index = contact.roles.indexOf(item.name);
      const role = contact.roles[index];

      // remove role
      if (index >= 0) contact.roles.splice(index, 1);

      // set associated legacy fields role to null
      this.nullifyLegacyField(role, contact);
    },
    isRequired(role) {
      switch (role) {
        case 'Main Contact':
        case 'Local Contact':
        case 'Portal Admin':
        case 'Order Notifications':
          return true;
        default:
          return false;
      }
    },
    validate() {
      if (this.$refs.contact_form.validate()) {
        if (this.action !== 'edit') {
          this.appendContact(this.contactForm);
          this.assignMenu = true;
        } else {
          // reserved for update and create
          this.updateContact();
        }
        // resets
        this.contactForm.roles.value = [];
        this.reset();
      }

      setTimeout(() => {
        this.resetValidation();
      }, 3000);
    },
    reset() {
      this.$refs.contact_form.reset();
    },
    resetValidation() {
      this.$refs.contact_form.resetValidation();
    },
    nullifyLegacyField(role, contact) {
      let index;
      switch (role) {
        case 'Main Contact':
          this.legacyFields.mcp_name = '';
          this.legacyFields.mcp_email = '';
          this.legacyFields.mcp_phone = '';
          break;
        case 'Local Contact':
          this.legacyFields.lcon_name = '';
          this.legacyFields.lcon_email = '';
          this.legacyFields.lcon_phone = '';
          break;
        case 'Emergency Contact':
          this.legacyFields.emergency_contact_email = '';
          this.legacyFields.ec_office = '';
          break;
        case 'Portal Admin':
          this.legacyFields.portal_name = '';
          this.legacyFields.portal_email = '';
          this.legacyFields.portal_phone = '';
          break;
        /* eslint-disable */
        case 'Order Notifications':
          const notifName = _.cloneDeep(this.legacyFields.notif_name);
          index = notifName.indexOf(`${contact.first} ${contact.last}`);
          if (index >= 0) notifName.splice(index, 1);
          this.legacyFields.notif_name = [...notifName];

          const notifEmail = _.cloneDeep(this.legacyFields.notif_email);
          index = notifEmail.indexOf(contact.email);
          if (index >= 0) notifEmail.splice(index, 1);
          this.legacyFields.notif_email = [...notifEmail];

          const notifPhone = _.cloneDeep(this.legacyFields.notif_phone);
          index = notifPhone.indexOf(contact.phone);
          if (index >= 0) notifPhone.splice(index, 1);
          this.legacyFields.notif_phone = [...notifPhone];
          break;
        case 'Colo Access':
          const coloName = _.cloneDeep(this.legacyFields.colo_name);
          index = coloName.indexOf(`${contact.first} ${contact.last}`);
          if (index >= 0) coloName.splice(index, 1);
          this.legacyFields.colo_name = [...coloName];

          const coloEmail = _.cloneDeep(this.legacyFields.colo_email);
          index = coloEmail.indexOf(contact.email);
          if (index >= 0) coloEmail.splice(index, 1);
          this.legacyFields.colo_email = [...coloEmail];

          const coloPhone = _.cloneDeep(this.legacyFields.colo_phone);
          index = coloPhone.indexOf(contact.phone);
          if (index >= 0) coloPhone.splice(index, 1);
          this.legacyFields.colo_phone = [...coloPhone];
          break;
        /* eslint-enable */
        case 'IT Vendor':
          this.legacyFields.vendor_contact_name = '';
          this.legacyFields.vendor_contact_email = '';
          this.legacyFields.vendor_contact_number = '';
          break;
        case 'PBX - Phone System Vendor':
          this.legacyFields.pbx_vendor_contact_name = '';
          this.legacyFields.pbx_vendor_contact_email = '';
          this.legacyFields.pbx_vendor_contact_number = '';
          break;
        default:
          break;
      }
    },
    formatContactsForOldSystem(contacts) {
      // assign all contacts for new system
      contacts = _.cloneDeep(contacts);
      this.legacyFields.contacts = [...contacts];

      // assign values for legacy support
      contacts.forEach((contact) => {
        contact.roles.forEach((role) => {
          switch (role) {
            case 'Main Contact':
              this.legacyFields.mcp_name = `${contact.first} ${contact.last}`;
              this.legacyFields.mcp_email = contact.email;
              this.legacyFields.mcp_phone = contact.phone;
              break;
            case 'Local Contact':
              this.legacyFields.lcon_name = `${contact.first} ${contact.last}`;
              this.legacyFields.lcon_email = contact.email;
              this.legacyFields.lcon_phone = contact.phone;
              break;
            case 'Emergency Contact':
              this.legacyFields.emergency_contact_email = contact.email;
              this.legacyFields.ec_office = contact.phone;
              break;
            case 'Portal Admin':
              this.legacyFields.portal_name = `${contact.first} ${contact.last}`;
              this.legacyFields.portal_email = contact.email;
              this.legacyFields.portal_phone = contact.phone;
              break;
            case 'Order Notifications':
              this.legacyFields.notif_name = [...this.legacyFields.notif_name, `${contact.first} ${contact.last}`];
              this.legacyFields.notif_email = [...this.legacyFields.notif_email, contact.email];
              this.legacyFields.notif_phone = [...this.legacyFields.notif_phone, contact.phone];
              break;
            case 'Colo Access':
              this.legacyFields.colo_name = [...this.legacyFields.colo_name, `${contact.first} ${contact.last}`];
              this.legacyFields.colo_email = [...this.legacyFields.colo_email, contact.email];
              this.legacyFields.colo_phone = [...this.legacyFields.colo_phone, contact.phone];
              break;
            case 'IT Vendor':
              this.legacyFields.vendor_contact_name = `${contact.first} ${contact.last}`;
              this.legacyFields.vendor_contact_email = contact.email;
              this.legacyFields.vendor_contact_number = contact.phone;
              break;
            case 'PBX - Phone System Vendor':
              this.legacyFields.pbx_vendor_contact_name = `${contact.first} ${contact.last}`;
              this.legacyFields.pbx_vendor_contact_email = contact.email;
              this.legacyFields.pbx_vendor_contact_number = contact.phone;
              break;
            default:
              break;
          }
        });
      });
    },
    registerFormChange(contacts, generalData) {
      this.formatContactsForOldSystem(contacts);
      const keys = Object.keys(this.legacyFields).concat(Object.keys(generalData));
      keys.forEach((key) => {
        this.updateStoreFormData({
          data: this.legacyFields[key] || generalData[key],
          main: 'general',
          sub: key,
        });
      });
    },
    setContactIndex(index) {
      this.editingRole = index;
    },
    hasRole(role) {
      const matches = (this.addedContacts || []).filter(
        (contact) => Array.isArray(contact.roles) && contact.roles.includes(role),
      );
      return matches || false;
    },
    // removeContactByRole(role) {
    //   const contacts = this.formData.contacts || [];
    //   const contact = contacts.find(
    //     (c) => Array.isArray(c.roles) && c.roles.includes(role),
    //   );
    //   if (!contact) return false;
    //   contact.roles = contact.roles.filter((r) => r !== role);
    //   return contact;
    // },
    removeRoleFromContact(idx, role) {
      const contacts = this.formData.contacts || [];
      const contact = contacts.find((c) => c.idx === idx);
      if (!contact) return false;

      // If the role isn't there, do nothing
      if (!Array.isArray(contact.roles) || !contact.roles.includes(role)) return false;

      // Remove just the requested role from the contact
      contact.roles = contact.roles.filter((r) => r !== role);

      // If roles remain, keep the contact
      if (contact.roles.length > 0) return contact;
      // Remove contact from list
      this.formData.contacts = contacts.filter((c) => c.idx !== idx);
      return contact;
    },
    getContactField(contact, field) {
      const raw = contact[field];
      switch (field) {
        case "address":
          return this.formData.generalData.ap_address;
        case "pin":
          return this.formData.generalData.master_pin;
        case "company":
          if (contact.roles.includes("Billing Contact")) {
            return this.formData.generalData.ap_name;
          }
          if (contact.roles.includes("IT Vendor")) {
            return this.formData.generalData.vendor_company_name;
          }
          if (contact.roles.includes("PBX - Phone System Vendor")) {
            return this.formData.generalData.pbx_vendor_company_name;
          }
          return "";
        case "ordernumber":
          return this.formData.generalData.purchase_order;
        default:
          if (!contact) return '';
          if (raw && typeof raw === 'object' && raw.value !== undefined) return raw.value;
          return raw || '';
      }
    },
    getRolePriority(roleObj) {
      const { name } = roleObj;
      const filled = !!this.hasRole(name);

      const generalData = (this.formData && this.formData.generalData) ? this.formData.generalData : {};
      const hasVendor = generalData.has_vendor;
      const hasPbxVendor = generalData.has_pbx_vendor;

      // --- Special vendor roles rules ---
      if (name === 'IT Vendor') {
        if (hasVendor === 'n') return 4;// explicitly no vendor -> bottom
        if (hasVendor === 'y' && filled) return 4;// vendor exists and contact filled -> bottom
        return 1;// vendor needed (y but missing) OR unanswered -> near top (below required)
      }
      if (name === 'PBX - Phone System Vendor') {
        if (hasPbxVendor === 'n') return 4;
        if (hasPbxVendor === 'y' && filled) return 4;
        return 1;
      }
      // --- Normal roles rules ---
      if (roleObj.required && !filled) return 0;
      if (filled) return 3;
      return 2;
    },
    addedRole(roleName) {
      const contact = (this.formData.contacts || [])[0];
      if (!contact) return;

      // Let v-model update contact.roles first
      this.$nextTick(() => {
        const { roles } = contact;

        // Only act when the role is being added (not removed)
        if (!Array.isArray(roles) || !roles.includes(roleName)) return;

        const needsExtra = roleName === 'Billing Contact'
          || roleName === 'IT Vendor'
          || roleName === 'PBX - Phone System Vendor';

        if (!needsExtra) return;

        const fieldOk = (field) => {
          const v = this.getContactField(contact, field);
          return !!(v && String(v).trim());
        };

        const missing = roleName === 'Billing Contact'
          ? !(fieldOk('address') && fieldOk('company') && fieldOk('pin') && fieldOk('ordernumber'))
          : !fieldOk('company'); // IT Vendor / PBX Vendor require company

        if (!missing) return;

        // Make sure the "edit" path is used so validate() updates instead of appending a new contact
        if (contact.idx === undefined) {
          this.$set(contact, 'idx', 0);
        }

        this.idxToEdit = contact.idx;
        this.editingRole = roleName;
        this.action = 'edit';

        // Load existing contact into the form
        Object.keys(contact).forEach((key) => {
          if (this.contactForm[key]) {
            this.contactForm[key].value = contact[key];
          }
        });

        // Preserve roles (including the newly added one)
        if (this.contactForm.roles) {
          this.contactForm.roles.value = [...roles];
        }

        this.dialog = true;
      });
    },
    useForAllRoles() {
      const contact = this.formData.contacts?.[0];
      if (!contact) return;

      const roleNames = (this.unassignedVisibleRoles ?? []).map((r) => r.name);

      // Ensure roles is an array
      contact.roles = Array.isArray(contact.roles) ? contact.roles : [];

      // Add all role names (deduped)
      const merged = new Set([...contact.roles, ...roleNames]);
      contact.roles = Array.from(merged);

      // If you rely on addedRole() side effects, keep this:
      roleNames.forEach((name) => this.addedRole?.(name, true));
    },
    openAddMenu(role) {
      this.setContactIndex(role);
      if (this.isRetail) {
        this.action = 'create';
        this.menu = true;
      } else {
        this.contactForm.first.value = null;
        this.contactForm.last.value = null;
        this.contactForm.phone.value = null;
        this.contactForm.email.value = null;
        this.contactForm.company.value = null;
        this.contactForm.address.value = null;
        this.contactForm.pin.value = null;
        this.contactForm.ordernumber.value = null;

        this.dialog = true;
        this.action = 'create';
      }
    },

  },
  watch: {
    // Note: contacts is ONLY being watched, all legacy fields are exluded --jesse
    formData: {
      handler(val) {
        this.registerFormChange(val.contacts, val.generalData);
        this.permissionHandler(val.contacts);
      },
      deep: true,
    },
    contact: {
      handler() {
        if (this.contact !== "") {
          this.addContact();
        }
      },
    },
    generatePin(newVal) {
      if (newVal) {
        this.contactForm.pin.value = Math.floor(1000 + Math.random() * 9000);
      }
    },
    unassignedVisibleRoles: {
      immediate: true,
      handler(roles) {
        if (this.assignMenu && (!roles || roles.length === 0)) {
          this.assignMenu = false;
        }
      },
    },
  },
};
</script>

<style scoped>
.role-card {
  border: 2px solid;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.role-card--has {
  border-color: #2e7d32;
  /* green */
}

.role-card--missing {
  border-color: #c62828;
  /* red */
}

.role-card--optional {
  border-color: #0000FF;
}

.required-badge {
  top: 6px;
  left: 8px;
  color: #c62828;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.role-card__grid {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.role-card__left {
  flex: 1 1 40%;
  min-width: 240px;
}

.role-card__right {
  flex: 1 1 60%;
  min-width: 240px;
  padding-left: 12px;
  border-left: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
